import styled from 'styled-components'

export const OpmeRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  .MuiCheckbox-root {
    padding: 0;
    margin-right: 0.5rem;
    flex-shrink: 0;
  }
`
